import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import Core from '../core';
import { useQuery } from 'react-query';

async function gotoEmployee(user_id: number, options?: AxiosRequestConfig) {
  const api = Core.getInstance().api();
  const data = await api.post(`/authN?id=${user_id}`, null, options);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
export const ssoService = {
  gotoEmployee,
};
